/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountRequestSchema } from "./calculateDiscountRequestSchema.ts";
import { calculateDiscountSchema } from "./calculateDiscountSchema.ts";

export const orgUnitCartCalculateDiscountCreateQueryOnlyPromoSchema = z.boolean().optional().default(false).describe("Расчет только по промокоду");

export const orgUnitCartCalculateDiscountCreatePathOrgUnitIdSchema = z.uuid();

export const orgUnitCartCalculateDiscountCreateStatus200Schema = calculateDiscountSchema;

export const orgUnitCartCalculateDiscountCreateResponseSchema = orgUnitCartCalculateDiscountCreateStatus200Schema;

export const orgUnitCartCalculateDiscountCreateDataSchemaJson = calculateDiscountRequestSchema.optional();

export const orgUnitCartCalculateDiscountCreateDataSchemaXml = calculateDiscountRequestSchema.optional();

export const orgUnitCartCalculateDiscountCreateDataSchema = z.union([
	orgUnitCartCalculateDiscountCreateDataSchemaJson,
	orgUnitCartCalculateDiscountCreateDataSchemaXml,
]);
